import InstructionTableFilter from './instruction-table-filter';

export default InstructionTableFilter;